import React, { useEffect } from "react";
import { indexStore } from "../../../store/indexStore";
import Iterator from "../../utils/Iterator";
import { useTranslation } from "react-i18next";
import { BranchCardLoading, BranchCards } from "../../Cards/BranchCards";
import Visibility from "../../utils/Visibility";
import { Button } from "../../ui/button";
import AddBranchModel from "./AddBranchModel";
import { userTypes } from "src/enums/usersTpes";
import { Building2, PlusCircle, Building } from "lucide-react";

function Branches() {
  const { t } = useTranslation();

  const { branches, featchBranchesFunction, branchsLoading } = indexStore();
  
  useEffect(() => {
    featchBranchesFunction();
  }, [featchBranchesFunction]);

  const per = localStorage.getItem("role");
  const canAdd = per === userTypes.ADMIN;

  return (
    <div className="flex flex-col gap-6">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="p-3 rounded-lg bg-gradient-to-br from-primary/10 to-transparent border">
            <Building2 className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-foreground">{t("gloabl.branches")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("gloabl.manage_branches") || "View and manage restaurant branches"}
            </p>
          </div>
        </div>
        <Visibility visible={canAdd}>
          <AddBranchModel
            trigger={
              <Button size="lg" className="gap-2">
                <PlusCircle className="w-4 h-4" />
                {t("gloabl.add")} {t("gloabl.branch")}
              </Button>
            }
          />
        </Visibility>
      </div>

      {/* Branches Grid */}
      <div className="flex-1">
        <Visibility visible={!branchsLoading && branches.length > 0}>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Building className="w-5 h-5 text-primary" />
                <h3 className="text-lg font-semibold">
                  {t("gloabl.branches_found") || "Branches"} ({branches.length})
                </h3>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              <Iterator
                data={branches}
                render={(e) => <BranchCards element={e} key={e.id} />}
              />
            </div>
          </div>
        </Visibility>

        <Visibility visible={branchsLoading}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            <Iterator
              data={[1, 2, 3, 4, 5, 6]}
              render={(e, i) => <BranchCardLoading key={i} />}
            />
          </div>
        </Visibility>

        <Visibility visible={!branchsLoading && branches.length === 0}>
          <div className="flex flex-col items-center justify-center py-12 text-center text-muted-foreground">
            <Building className="w-16 h-16 mb-4 text-gray-300" />
            <p className="text-xl font-semibold mb-2">{t("gloabl.no_branches_found") || "No branches found"}</p>
            <p className="mb-4">{t("gloabl.no_branches_description") || "Create your first branch to get started"}</p>
            <Visibility visible={canAdd}>
              <AddBranchModel
                trigger={
                  <Button size="lg" className="gap-2">
                    <PlusCircle className="w-4 h-4" />
                    {t("gloabl.add")} {t("gloabl.branch")}
                  </Button>
                }
              />
            </Visibility>
          </div>
        </Visibility>
      </div>
    </div>
  );
}

export default Branches;
